import React, { PureComponent } from 'react';
import { Form, FormGroup, FormError } from '../../../../components/Forms/Forms';
import { Input } from '../../../../components/Forms/fields/index';
import rules from '../../../../components/Forms/rules';

class MultiFactorView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    const {
      user,
      formState,
      onFormUpdate,
      submitForm,
      codeFormState,
      submitCodeForm,
      onCodeFormUpdate,
      qrCode,
      secret,
    } = this.props;

    return user ? (
      <div className="multi-factor-container">
        <h3>2-Factor Authentication</h3>
        {user.multiFactorEnabled ? (
          <p className="success">2-Factor Authentication is enabled</p>
        ) : (
          <div>
            {qrCode ? (
              <div>
                <p>Instructions:</p>
                <ol>
                  <li>Download google authenticator app on your phone</li>
                  <li>Scan QR code using app</li>
                  <li>Enter code from app in form below QR Code and click "Submit Code"</li>
                </ol>
                <img src={qrCode} alt={secret}/>
                <Form state={codeFormState} onSubmit={submitCodeForm} onChange={onCodeFormUpdate}>
                  <FormGroup>
                    <label>Code</label>
                    <Input name="code" type="password" validate={[rules.required()]}/>
                    <FormError/>
                  </FormGroup>
                  <button className="button">Submit Code</button>
                </Form>
              </div>
            ) : (
              <div>
                <p className="warning">You do not have 2-factor authentication enabled. Please enable it or your account will be deactivated.</p>
                <div>
                  <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
                    <FormGroup>
                      <label>Password</label>
                      <Input name="password" type="password" validate={[rules.required()]}/>
                      <FormError/>
                    </FormGroup>
                    <button className="button">Generate 2-factor</button>
                  </Form>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    ) : null;
  }
}

export default MultiFactorView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MultiFactor/MultiFactor.view.js